import { Field, useFormikContext } from "formik";
import SVG from "react-inlinesvg";

const findConfiguredOverrides = (blocks, experimentName) => {
  const blockWithOverrides = blocks.reduce((acc, block) => {
    if (!block.overrides) {
      return acc;
    }
    const override = block.overrides.find((o) => {
      const criteria = o.criteria;
      if (!criteria) {
        return acc;
      }
      const applicableCriteria = criteria.filter((c) => {
        const variable = c.options.variable;
        if (!variable) {
          return false;
        }
        return variable === experimentName;
      });
      return applicableCriteria.length > 0;
    });
    if (override) {
      return [
        ...acc,
        {
          blockId: block.id,
        },
      ];
    }
    return acc;
  }, []);
  return blockWithOverrides;
};

function ABTestBlockEditor({ optionsPath, block }) {
  const { values } = useFormikContext();

  const experimentName = block.options.experimentName;
  const configuredOverrides = findConfiguredOverrides(values.blocks, experimentName);

  return (
    <>
      <div className="mb-4 flex flex-row gap-2">
        <div>
          <label
            className="block mb-1"
            htmlFor={`${optionsPath}.experimentName`}
          >
            Experiment Name
          </label>
          <p className="text-sm text-gray-500">This is the name of the experiment in growth book</p>
          <Field name={`${optionsPath}.experimentName`} />
        </div>
        <div>
          <label
            className="block mb-1"
            htmlFor={`${optionsPath}.controlVariationName`}
          >
            Control Name
          </label>
          <p className="text-sm text-gray-500">Control Name in Growth Book</p>
          <Field
            type="text"
            name={`${optionsPath}.controlVariationName`}
          />
        </div>
        <div>
          <label
            className="block mb-1"
            htmlFor={`${optionsPath}.testVariationName`}
          >
            Test Name
          </label>
          <p className="text-sm text-gray-500">Test Name in Growth Book</p>
          <Field
            type="text"
            name={`${optionsPath}.testVariationName`}
          />
        </div>
      </div>
      <div className="flex flex-row gap-2">
        <div className="mb-4">
          <label
            className="block mb-1"
            htmlFor={`${optionsPath}.population`}
          >
            Population
          </label>
          <Field name={`${optionsPath}.population`}>
            {({ field }) => (
              <select {...field}>
                <option value="all">All</option>
                <option value="trial">Trial</option>
                <option value="members">Members</option>
              </select>
            )}
          </Field>
        </div>
        <div className="mb-4">
          <label
            className="block mb-1"
            htmlFor={`${optionsPath}.skipFlaggedContent`}
          >
            Skip Flagged Content
          </label>
          <Field
            name={`${optionsPath}.skipFlaggedContent`}
            type="checkbox"
          />
        </div>
        <div className="mb-4">
          <label
            className="block mb-1"
            htmlFor={`${optionsPath}.assignmentStrategy`}
          >
            Assignment Strategy
          </label>
          <Field name={`${optionsPath}.assignmentStrategy`}>
            {({ field }) => (
              <select {...field}>
                <option value="request">Request</option>
                <option value="user">User</option>
              </select>
            )}
          </Field>
        </div>
        <div className="mb-4">
          <label
            className="block mb-1"
            htmlFor={`${optionsPath}.percentage`}
          >
            Percentage (0-100)
          </label>
          <Field name={`${optionsPath}.percentage`}>
            {({ field }) => (
              <input
                type="number"
                min={0}
                {...field}
              />
            )}
          </Field>
        </div>
      </div>
      {configuredOverrides.length === 0 && (
        <div className="flex flex-row gap-2 items-center justify-center">
          <SVG
            height={24}
            width={24}
            src="/assets/warning-square.svg"
          />
          <p className="text-sm">No Overrides Present Yet (This A/B Test has no changes)</p>
        </div>
      )}
      {configuredOverrides.length > 0 && (
        <div className="flex flex-row gap-2 items-center justify-center">
          <p className="text-sm">This A/B Test changes: {configuredOverrides.map((o) => o.blockId).join(", ")}</p>
        </div>
      )}
    </>
  );
}

export default ABTestBlockEditor;
